const Privacy = () => {
  return (
    <div className="min-h-screen bg-background pt-32 pb-20" data-testid="privacy-page">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-8">
            Privacy Policy
          </h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-muted-foreground leading-relaxed mb-6">
              Last updated: February 2026
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Information We Collect
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              When you submit a Private Property Brief or contact form, we collect the personal information 
              you provide, including your name, email address, telephone number, and details about your 
              property requirements.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              How We Use Your Information
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We use your information solely to:
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-2 mb-4">
              <li>Respond to your enquiry</li>
              <li>Conduct a property search based on your requirements</li>
              <li>Communicate with you about relevant opportunities</li>
              <li>Provide the services you have requested</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Data Protection
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We take appropriate measures to protect your personal information. Your data is stored 
              securely and is only accessed by authorised personnel who need it to provide our services.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Data Retention
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              We retain your personal information only for as long as necessary to fulfil the purposes 
              for which it was collected, or as required by law.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Your Rights
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              You have the right to access, correct, or delete your personal information. 
              To exercise these rights, please contact us through the contact form on our website.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">
              Contact
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              For any questions about this Privacy Policy, please use our contact form.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
